import React, { createContext, useContext, useState, useEffect } from "react";
import { getUserDetails } from "./api/user";

const AccessLevelContext = createContext();

export const AccessLevelProvider = ({ children }) => {
    const [accessLevel, setAccessLevel] = useState(() => {
        const savedAccessLevel = localStorage.getItem("accessLevel");
        return savedAccessLevel ? parseInt(savedAccessLevel, 10) : null;
    });

    const [userId, setUserId] = useState(null);

    useEffect(() => {
        if (accessLevel !== null) {
            localStorage.setItem("accessLevel", accessLevel);
        }
    }, [accessLevel]);

    // 👇 renamed into a reusable function instead of an automatic mount-only effect
    const refreshUserId = async () => {
        try {
            const data = await getUserDetails();
            setUserId(data.client_id); // ✅ correct field name
        } catch (err) {
            console.warn("Failed to fetch user details:", err);
        }
    };

    // Still run once on mount too — covers the case where someone refreshes
    // the page while already logged in (token already exists)
    useEffect(() => {
        const token = sessionStorage.getItem("accessToken");
        if (token) {
            refreshUserId();
        }
    }, []);

    return (
        <AccessLevelContext.Provider value={{ accessLevel, setAccessLevel, userId, refreshUserId }}>
            {children}
        </AccessLevelContext.Provider>
    );
};

export const UseAccessLevel = () => useContext(AccessLevelContext);